import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const MarginAccountsServiceContext = createContext(undefined)

const MarginAccountsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={MarginAccountsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/org/margin_accounts`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/org/margin_accounts/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/org/margin_accounts${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

MarginAccountsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useMarginAccountsService = () => {
  const context = useContext(MarginAccountsServiceContext)
  if (context === undefined) {
    throw new Error('MarginAccountsServiceContext was not provided. Make sure your component is a child of the MarginAccountsServiceProvider.')
  }
  return context
}

const useMarginAccountsQuery = ({query, ...otherProps}) => {
  const marginAccountsService = useMarginAccountsService()
  return useSimpleQuery({
    queryKey: `margin_accounts-list-${JSON.stringify(query)}`,
    queryFn: async () => marginAccountsService.list(query),
    ...otherProps
  })
}

const useMarginAccountQuery = ({id, enabled, ...otherProps}) => {
  const marginAccountsService = useMarginAccountsService()
  return useSimpleQuery({
    queryKey: `margin_accounts-get-${id}`,
    queryFn: async () => marginAccountsService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {MarginAccountsServiceProvider, useMarginAccountsService, useMarginAccountsQuery, useMarginAccountQuery}
